var map = {
	"./Carda1.png": 60,
	"./Carda2.png": 129,
	"./Carda3.png": 657,
	"./Carda4.png": 757,
	"./Carda5.png": 258,
	"./Carda6.png": 727,
	"./Carda7.png": 668,
	"./Carda8.png": 673,
	"./Carda9.png": 594,
	"./Cardb1.png": 89,
	"./Cardb2.png": 955,
	"./Cardb3.png": 441,
	"./Cardb4.png": 163,
	"./Cardb5.png": 720,
	"./Cardb6.png": 452,
	"./Cardb7.png": 423,
	"./Cardb8.png": 710,
	"./Cardb9.png": 46,
	"./Cardbonus.png": 112,
	"./Cardc1.png": 24,
	"./Cardc2.png": 518,
	"./Cardc3.png": 254,
	"./Cardc4.png": 175,
	"./Cardc5.png": 886,
	"./Cardc6.png": 497,
	"./Cardc7.png": 676,
	"./Cardc8.png": 418,
	"./Cardc9.png": 794,
	"./Cardx.png": 219,
	"./Cardy.png": 758,
	"./Cardz.png": 357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;